var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-resource-link",
      attrs: { "data-sortindex": _vm.sortIndex }
    },
    [
      _vm.mode === "view"
        ? [
            _c(
              "div",
              { staticClass: "c-resource-link__link t-space-between" },
              [
                _c("a", { attrs: { href: _vm.link, target: "_blank" } }, [
                  _vm._v(_vm._s(_vm.text))
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "c-resource-link__sorting" },
                    [
                      _c(
                        "can",
                        { attrs: { i: "manage", a: _vm.processType } },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "c-form",
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.handleSubmit($event)
                                }
                              }
                            },
                            [
                              _vm.sortIndex !== _vm.sortIndexes[0]
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "c-button c-button--linkstyle c-button--reset c-process-step__move-up c-resource-link__move-up",
                                      attrs: {
                                        title: "Flytta upp",
                                        type: "submit"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.setSubmitType("moveUp")
                                        }
                                      }
                                    },
                                    [
                                      _c("vue-icon", {
                                        attrs: {
                                          name: "expand",
                                          size: "c-icon--17px"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _vm.sortIndex ===
                              _vm.sortIndexes[_vm.sortIndexes.length - 1]
                                ? _c("br")
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sortIndex !==
                              _vm.sortIndexes[_vm.sortIndexes.length - 1]
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "c-button c-button--linkstyle c-button--reset",
                                      attrs: {
                                        title: "Flytta ner",
                                        type: "submit"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.setSubmitType("moveDown")
                                        }
                                      }
                                    },
                                    [
                                      _c("vue-icon", {
                                        attrs: {
                                          name: "expand",
                                          size: "c-icon--17px"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("can", { attrs: { i: "manage", a: _vm.processType } }, [
              _c(
                "button",
                {
                  staticClass:
                    "c-button c-button--linkstyle c-button--reset c-resource-link__button",
                  attrs: { type: "button" },
                  on: { click: _vm.goToEditMode }
                },
                [
                  _c("vue-icon", {
                    attrs: { name: "edit", size: "c-icon--17px" }
                  })
                ],
                1
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.mode == "create" || _vm.mode == "edit"
        ? [
            _c(
              "div",
              {
                staticClass:
                  "c-resource-link__container t-margin-top-s t-margin-bottom-s t-border-green",
                class: {
                  "t-background-white":
                    _vm.mode == "create" || _vm.mode == "edit"
                }
              },
              [
                _c("div", { staticClass: "t-margin-left-s t-margin-right-s" }, [
                  _c(
                    "form",
                    {
                      staticClass: "c-form",
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.handleSubmit($event)
                        }
                      }
                    },
                    [
                      _c("fieldset", [
                        _c("div", { staticClass: "o-grid" }, [
                          _c(
                            "div",
                            {
                              staticClass: "o-grid__column",
                              attrs: { "data-size": "sm:12 md:6 lg:6" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "c-form__item" },
                                [
                                  _c("vue-input", {
                                    ref: "text",
                                    attrs: {
                                      label: "Namn på mall",
                                      "input-id": "text",
                                      value: _vm.text
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "o-grid__column",
                              attrs: { "data-size": "sm:12 md:6 lg:6" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "c-form__item" },
                                [
                                  _c("vue-input", {
                                    ref: "link",
                                    attrs: {
                                      label: "Länk till mall",
                                      "input-id": "link",
                                      value: _vm.link
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "c-resource-link-input__sub" },
                                [
                                  _vm._v(
                                    "Klistra in länken till där man hittar mallen"
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.mode === "create"
                        ? [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "c-button c-button--primary t-margin-bottom-s",
                                attrs: { type: "submit" },
                                on: {
                                  click: function($event) {
                                    return _vm.setSubmitType("create")
                                  }
                                }
                              },
                              [_vm._v("Skapa länk")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "c-button c-button--linkstyle c-button--reset",
                                attrs: { type: "button" },
                                on: { click: _vm.cancelCreateResourceLink }
                              },
                              [_vm._v("Avbryt")]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mode === "edit"
                        ? [
                            _c(
                              "div",
                              { staticClass: "t-space-between" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "t-margin-bottom-xs" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "c-button c-button--primary t-margin-top-s t-margin-bottom-s",
                                        attrs: { type: "submit" },
                                        on: {
                                          click: function($event) {
                                            return _vm.setSubmitType("edit")
                                          }
                                        }
                                      },
                                      [_vm._v("Spara")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "c-button c-button--linkstyle c-button--reset",
                                        attrs: { type: "button" },
                                        on: {
                                          click: _vm.cancelEditResourceLink
                                        }
                                      },
                                      [_vm._v("Avbryt")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "c-button c-button--linkstyle c-button--linkstyle__secondary c-button--reset t-margin-bottom-xs",
                                    attrs: { type: "submit" },
                                    on: { click: _vm.toggleDeleteLinkModal }
                                  },
                                  [
                                    _c("vue-icon", {
                                      attrs: {
                                        name: "delete",
                                        size: "c-icon--17px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "c-button__title" },
                                      [_vm._v("Ta bort länk")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "modal",
                                  {
                                    attrs: { show: _vm.showDeleteLinkModal },
                                    on: {
                                      closeModal: _vm.toggleDeleteLinkModal
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-modal__content t-background-white t-text-align-center"
                                      },
                                      [
                                        _c(
                                          "h1",
                                          {
                                            staticClass:
                                              "t-text-style-alpha t-margin-bottom-s"
                                          },
                                          [
                                            _vm._v(
                                              'Länken "' +
                                                _vm._s(_vm.text) +
                                                '" kommer att tas bort'
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "form",
                                          {
                                            staticClass: "c-form",
                                            on: {
                                              submit: function($event) {
                                                $event.preventDefault()
                                                return _vm.handleSubmit($event)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "c-button c-button--linkstyle c-button--reset t-margin-top-m",
                                                on: {
                                                  click:
                                                    _vm.toggleDeleteLinkModal
                                                }
                                              },
                                              [_vm._v("Avbryt")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "c-button c-button--primary t-margin-top-m",
                                                attrs: { type: "submit" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setSubmitType(
                                                      "delete"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Ta bort länk")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }